export enum JobStatus {
    SCHEDULED = 'scheduled',
    IN_PROGRESS = 'inProgress',
}

export enum JobType {
    LOCAL = 'LOCAL',
    SHAREPOINT = 'SHAREPOINT',
}

export enum StorageLocation {
    SERVER = 'SERVER',
    COLLECTION = 'COLLECTION',
}

// GET /jobs
export interface JobResponse {
    id: number;
    name: string;
    type: string;
    prompt: string;
    cronExpression: string;
    inputPath: string;
    outputPath: string;
    sourceCollectionId: number;
    targetCollectionId: number;
    targetCollectionName: string;
    nextFireTime: string; // ISO 8601 w UTC
    prevFireTime: string; // ISO 8601 w UTC
    isRunning: boolean;
    sharePointFolderPath: string;
}

// POST /jobs/ => jobConfigurationId: number
export interface JobParamsRequest {
    cronExpression: string;
    prompt?: string;
    targetCollectionName?: string;
    targetCollectionId?: number;
    sourceCollectionId?: number;
    inputPath?: string;
    outputPath?: string;
    type?: string;
    inputSharepointPath?: string;   // for POST SharePoint type
}

// PUT /jobs/:id
export interface JobSharePointRequest {
    cronExpression: string;
    targetCollectionId?: number;
    sharePointFolderPath?: string;
}

export interface JobFormState {
    cronExpression: string;
    targetCollectionName: string;
    targetCollectionId: number | '';
    sourceCollectionId: number | '';
    inputPath: string;
    outputPath: string;
    prompt: string;
    type: string;
}